import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import home from "../json/home.json";
import plans from "../json/plans.json";
import quote from "../json/quoteforms.json";
import contact from "../json/contactus.json";
import about from "../json/aboutus.json";
import privacyAdvertise from "../json/privacyadvertise.json";

const AboutView = () => import("../views/AboutView.vue");
const ContactView = () => import("../views/ContactView.vue");
const ErrorView = () => import("../views/ErrorView.vue");
const HomeView = () => import("../views/HomeView.vue");
const PlansView = () => import("../views/PlansView.vue");
const QuoteView = () => import("../views/QuoteView.vue");
const PrivacyAdvertiseView = () => import("../views/PrivacyAdvertiseView.vue");

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      ...home,
    },
    props: () => ({
      content: home.content
    })
  },
  {
    path: "/plans",
    name: "plans",
    component: PlansView,
    meta: {
      ...plans,
    },
    props: () => ({
      content: plans.content
    })
  },
  {
    path: "/quote",
    name: "quote",
    component: QuoteView,
    meta: {
      ...quote,
    },
    props: () => ({
      content: quote.content
    })
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
    meta: {
      ...contact,
    },
    props: () => ({
      content: contact.content
    })
  },
  {
    path: "/pugaYasociados",
    name: "pugaYasociados",
    component: AboutView,
    meta: {
      ...about,
    },
    props: () => ({
      content: about.content
    })
  },
  {
    path: "/aviso_de_privacidad",
    name: "privacy",
    component: PrivacyAdvertiseView,
    meta: {
      ...privacyAdvertise,
    },
    props: () => ({
      content: privacyAdvertise.content
    })
  },
  {
    path: "/:pathMatch(.*)",
    name: "notfound",
    component: ErrorView,
    meta: {
      title: "Página no encontrada",
      description: "La página que buscas no existe",
      icon: "pi pi-exclamation-triangle",
    },
  }
];

const history = createWebHistory("/");

const router = createRouter({ history, routes });

export { router, routes };